import React, { Component } from 'react'

class NoResults extends Component {
  render() {
    if (this.props.display === false) {
      return null
    }

    return (
      <React.Fragment>
        <section className="container">
          <div className="row no-gutters">
            <div className="col-12">
              <div className="d-flex flex-column flex-wrap">
                <p className="results-counter-text">
                  {' '}
                  {this.props.resultCount}{' '}
                </p>

                <h2 className="search-results-title"> {this.props.title} </h2>
                <h5 className="search-results-message">
                  {' '}
                  {this.props.message}{' '}
                </h5>

                <div className="action-buttons no-results-actions">
                  <a
                    className="search-results-action"
                    onClick={this.props.action}
                  >
                    {this.props.actionText}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
      </React.Fragment>
    )
  }
}

export default NoResults
